<!--我的材料-->
<template>
  <div>
    <Row>
      <Col span="22">
        <div class="container_wang_company">
          <Form ref="ruleCustom" :model="tableData1" :rules="ruleCustom" :label-width="0">
          <table>
            <tr>
              <td class="title" colspan="2">公司信息</td>
            </tr>
            <tr>
              <td style="height: 90px">营业执照</td>
              <td style="height: 90px;" class="Magnifying">
                <div style="display: flex;align-items:center;width:100%">
                   <FormItem prop="license" v-if="tableData.idImgStatus!==2">
                     <div style="display: flex">
                       <upload-img :imgName="tableData1.license" @fetchImgUrl="uploadLicense"
                                   v-model="tableData1.license" v-if="show || tableData.checkId ===null"></upload-img>
                       <img-magnifying :imgSrc="tableData.license |imgSrc" ></img-magnifying>
                     </div>
                   </FormItem>
                </div>
              </td>
            </tr>
            <tr>
              <td style="height:90px;">法人身份证</td>
              <td style="height:90px;" class="Magnifying">
                <div style="display: flex;align-items:center">
                  <FormItem prop="financial" v-if="tableData.idImgStatus!==2">
                    <div style="display: flex">
                      <upload-img :imgName="tableData1.idCard" @fetchImgUrl="uploadIdCard"
                                  v-model="tableData1.idCard" style="align-self: center" v-if="show || tableData.checkId ===null"></upload-img>
                      <img-magnifying :imgSrc="tableData.idCard | imgSrc"></img-magnifying>
                    </div>
                  </FormItem>
                </div>
              </td>
            </tr>
          </table>
          </Form>
          <Row>
            <Col span="4" offset="8">
              <my-button @confirm="save" v-if="show">保存</my-button>
              <my-button @confirm="edit" v-if="!show">修改</my-button>
            </Col>
            <Col span="4">
              <my-button @confirm="cancel" v-if="show">取消</my-button>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>

  </div>
</template>
<script>
  import ApiClient from "@/api/ApiClient";
  import MyButton from '@/components/MyButton'
  import tableEdit from '@/components/tableEdit'
  import AppUploadImg from '@/components/AppUploadImg'
  import imgMagnifying from '@/components/imgMagnifying'
  import uploadImg from '@/components/uploadImg'
  export default {
    name: "material",
    components: {
      MyButton,
      tableEdit,
      AppUploadImg,
      imgMagnifying,
      uploadImg
    },
    data() {
      const validatelLicense = (rule, value, callback) => {
        if (value === '') {
          return callback(new Error('请上传营业执照图片'));
        } else {
          callback();
        }
      };
      const validateIdCard=(rule,value,callback)=>{
        if(!value){
          return callback(new Error('请上传法人身份证照片'))
        }else{
          callback();
        }
      };
      return {
        formCustom: {

        },
        tableData:{
          license:'',
          idCard:'',
        },
        tableData1:{
          license:'',
          idCard:'',
        },
        show: false,
        editable: false,
        ruleCustom: {
          license: [
            {validator: validatelLicense, trigger: 'blur'}
          ],
          idCard:[
            {validator:validateIdCard,trigger:'blur'}
          ],
        },
      }
    },
    mounted() {
      ApiClient.get('/desktop/profile/detail.do').then(data => {
        this.formCustom = data;

      })
    },
    activated() {
      ApiClient.get('/desktop/profile/detail.do').then(data => {
        this.formCustom = data;
      })
    },
    methods: {
      uploadLicense(evtValue){
        this.tableData1.license=evtValue;
      },
      uploadIdCard(evtValue){
        this.tableData1.idCard=evtValue;
      },
      edit() {
        this.show = true;
        this.editable = true;
      },
      save() {
        // if (this.formCustom.address.trim() === '') {
        //   this.$Message.error('请填写联系地址');
        //   return false
        // }
        this.show = false;
        this.editable = false;
        // ApiClient.put('/desktop/profile/update.do', this.formCustom).then(data => {
        //   ApiClient.get('/desktop/profile/detail.do').then(data => {
        //     this.formCustom = data;
        //   })
        // })
      },
      cancel() {
        this.show = false;
        // ApiClient.get('/desktop/profile/detail.do').then(data => {
        //   this.formCustom = data;
        // })

      },
      confirm() {
        // ApiClient.get('/desktop/profile/checkFail.do', {id: this.formCustom.detailIdNew}).then(data => {
        //   ApiClient.get('/desktop/profile/detail.do').then(data => {
        //     this.formCustom = data;
        //
        //   })
        // })
      },

    }
  }
</script>
<style scoped lang="less">
  .title {
    font-weight: 700;
  }
  table {
    border-collapse: collapse;
    margin-left: 60px;
    margin-top: 16px;
    width: 100%;
    tr td {
      border: 1px solid #D8D8D8;
      height: 42px;
      padding-left: 20px;
    }
    tr td:nth-child(2n+1) {
      width: 17%;
    }
    tr td:nth-child(2n) {
      width: 57%;
    }
  }
  table tr:nth-child(1), table tr:nth-child(3), table tr:nth-child(5), table tr:nth-child(7) {
    background-color: #F6F6F5;
  }
</style>
<style lang="less">
  .container_wang_company button {
    margin-left: 46%;
    margin-top: 60px;
 }
</style>
<style>
  .container_wang_company_modal .ivu-modal {
    top: 50%;
    margin-top: -80px;
  }
  .container_wang_company .ivu-form-item {
    margin-bottom: 0;
  }
  .container_wang_company .ivu-form-inline .ivu-form-item {
    width: 100%;
  }
  .container_wang_company .ivu-form-item-error-tip {
    display: inline;
    position: static;
  }
  .container_wang_company .ivu-input-wrapper {
    width: auto;
    display: inline;
  }
</style>





// WEBPACK FOOTER //
// src/pages/myProfile/material.vue